import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'bg-btn-toggle',
    templateUrl: './btn-toggle.component.html',
    imports: [CommonModule],
})
export class BtnToggleComponent implements OnInit {
    @Input() min: number;
    @Input() max: number;
    @Input() value: number;
    @Input() id: number;
    @Input() isMultistake: boolean;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
    prebuy_tickets: any;
    no_of_tickets: number;
    constructor() {}
    ngOnInit() {
        this.prebuy_tickets = [];
        if (this.isMultistake) this.prebuy_tickets.push(1);
        else {
            this.prebuy_tickets.push(6);
            this.prebuy_tickets.push(12);
            this.prebuy_tickets.push(24);
            this.prebuy_tickets.push(48);
            this.prebuy_tickets.push('Max');
        }
    }
    setTickets(no_of_tickets_selected: any) {
        if (no_of_tickets_selected == 'Max') {
            no_of_tickets_selected = +this.max;
        }
        if (no_of_tickets_selected > +this.max) return;

        this.onSelected.emit({
            selectedValue: +no_of_tickets_selected,
            id: this.id,
        });
    }
}
